import { useClientPortalAPI } from "@certn/api";

interface UseFetchCobrandingOptions {
  enabled?: boolean;
}

/** Shared by all subscribers to the cobranding GET key (e.g. BasePage + BrandingContext). */
export const COBRANDING_SWR_OPTIONS = { revalidateOnFocus: false } as const;

export function useFetchCobranding(options: UseFetchCobrandingOptions = {}) {
  const { enabled = true } = options;

  const { data, isLoading, error, mutate } = useClientPortalAPI(
    enabled
      ? "/api/internal/client-portal/customer-accounts/cobranding/"
      : null,
    undefined,
    COBRANDING_SWR_OPTIONS
  );

  return {
    primaryColor: data?.primary_brand_color || null,
    optimalTextColor: data?.optimal_text_color || null,
    isLoading,
    error,
    mutate,
  };
}
